import './InsightsCompleteDetails.scss';

import * as React from 'react';

import { sendViewInsightParticipantsEvent } from '~analytics/index';
import { translate } from '~l10n/client';
import { FocusIndicator } from '~shared/components/FocusIndicator';
import { Popover } from '~shared/components/Popover';

import { Insights } from '../../../../api/activities/insights/insightSchema';

interface InsightsCompleteDetailProps
  extends Pick<Insights, 'description' | 'topic'> {
  questionNumbers: Array<number>;
  insightNumber: number;
  participantNames: Array<string>;
}
export function InsightsCompleteDetail({
  description,
  questionNumbers,
  participantNames,
  topic,
  insightNumber,
}: InsightsCompleteDetailProps) {
  const handleParticipantsClick = () => {
    sendViewInsightParticipantsEvent();
  };

  return (
    <div className="details-insight-grid gap-x-2 font-sans text-base leading-8">
      <span className="insight font-600">{insightNumber}.</span>
      <span className="title font-600">
        {topic} ({questionNumbers.map((num) => `Q${num}`).join(', ')})
      </span>
      <div className="explanation">
        <Popover
          mode="click"
          maxWidth={320}
          disableArrow
          content={
            <div className="font-sans leading-10 text-base max-w-112">
              <ul>
                {participantNames.map((name) => (
                  <li key={name} className="whitespace-no-wrap truncate">
                    {name}
                  </li>
                ))}
              </ul>
            </div>
          }
        >
          <button
            className="participants p-0 cursor-pointer text-cyan-700 font-600 bg-transparent border-none leading-8 font-sans text-base w-auto h-auto"
            onClick={handleParticipantsClick}
          >
            {participantNames.length > 1
              ? translate('{0} participants').format(participantNames.length)
              : translate('1 participant')}
            <FocusIndicator />
          </button>
        </Popover>{' '}
        <span>{description}</span>
      </div>
    </div>
  );
}
